export default __webpack_public_path__ + "static/media/title.172bace6.jpg";